// --- Core ---
import {reject} from "underscore";
// --- SaniQ ---
import {
  FETCH_COMPLETED,
  FETCH_ENTRIES_COMPLETED,
  FETCH_ENTRIES_MEASUREMENTS_COMPLETED,
  FETCH_ENTRIES_MEASUREMENTS_FAILED,
  FETCH_ENTRIES_MEASUREMENTS_STARTED,
  FETCH_ENTRIES_STARTED,
  FETCH_STARTED,
  REMOVE_VISITE_ENTRY_COMPLETED,
  UPDATE_COMPLETED
} from "../constants/Visite";
import {Patient} from "../../../../../models/Patient";
import {PatientVisite, VisiteConfigEntry} from "../../../../../models/patient/Visite";

interface VisiteState {
  collection: Record<string, any>;
  configEntries: VisiteConfigEntry[];
  isFetching: boolean;
  measurements: Record<string, any>;
  model: PatientVisite;
  patient: Patient;
}

const initialState: VisiteState = {
  model: null,
  configEntries: [],
  collection: {},
  measurements: {},
  patient: {},
  isFetching: false
};

export function visite(state = initialState, action): VisiteState {
  switch (action.type) {
    case FETCH_STARTED:
      return {
        ...state,
        isFetching: true,
        model: initialState.model,
        configEntries: initialState.configEntries,
        collection: initialState.collection,
        patient: initialState.patient
      };
    case FETCH_COMPLETED:
      return {
        ...state,
        isFetching: false,
        configEntries: action.entries,
        patient: action.patient,
        model: action.model
      };
    case UPDATE_COMPLETED:
      return {
        ...state,
        model: action.model
      };
    case FETCH_ENTRIES_STARTED:
      return {
        ...state,
        isFetching: true,
        collection: initialState.collection,
        measurements: initialState.measurements
      };
    case FETCH_ENTRIES_COMPLETED:
      return {...state, isFetching: false, collection: action.collection};
    case FETCH_ENTRIES_MEASUREMENTS_STARTED: {
      const measurement = {};
      measurement[action.valueType] = {isFetching: true, collection: {}};
      const newMeasurements = Object.assign({}, state.measurements, measurement);

      return {...state, measurements: newMeasurements};
    }

    case FETCH_ENTRIES_MEASUREMENTS_COMPLETED: {
      const measurement = {};
      measurement[action.entryId] = {isFetching: false, collection: action.measurements};
      const newMeasurements = Object.assign({}, state.measurements, measurement);

      return {...state, measurements: newMeasurements};
    }

    case FETCH_ENTRIES_MEASUREMENTS_FAILED: {
      const measurement = {};
      measurement[action.entryId] = {isFetching: false, hasError: true};
      const newMeasurements = Object.assign({}, state.measurements, measurement);

      return {...state, measurements: newMeasurements};
    }

    case REMOVE_VISITE_ENTRY_COMPLETED: {
      const entries = reject(state.configEntries, (entry) => (entry.id === action.id));

      return {...state, configEntries: entries};
    }
    default:
      return state;
  }
}
